<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content d-flex flex-row" v-menu-permission="'list'">
            <DrawerHandler is-left class="col-lg-3 float-lg-left overflow-auto" style="height:750px" to-invisible>
            <!--EmFilterTree-->
            <em-filter-tree
                            filterEnable
                            :entity="modelName"
                            filterState="levelTreeFilter"
                            loadState="levelTreeNodes"
                            :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                            @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            </DrawerHandler>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="emLocationResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #customRowActions="{row}">
                                        <b-button-group>
                                            <em-button
                                                    v-if="$_emLevelTreeListMixin_getGrandParentId(row)"
                                                    type="gotoGrandParent"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       @click="$_emLevelTreeListMixin_gotoChild(row)">
                                            </em-button>
                                        </b-button-group>
                                    </template>

                                    <template #left-header>

                                      <em-button
                                          type="gotoChild"
                                          custom-icon="fa fa-copy"
                                          class="btn btn-outline-primary btn-sm"
                                          show-name custom-label="同步机旁库位置"
                                          @click="openJpkDialog">
                                      </em-button>

                                    </template>

                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>

        <el-dialog title="确定要同步机旁库信息到设备安装使用位置" :visible.sync="copyJpkDialogVisible" :close-on-click-modal='false' append-to-body >
          <el-form :model="createForm" ref="createForm" label-width="auto" :inline="true" :rules="rules">
            <el-form-item label="要同步的机旁库根节点编码" prop="code">
              <el-input v-model="createForm.code" placeholder="根节点编码"></el-input>
            </el-form-item>

          </el-form>
          <div><span class="el-dialog__title">同步的机旁库信息将用于设备档案中的高单价大型备件管理使用！</span></div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="copyJpkDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="copyJpkRecords()">同步</el-button>
          </div>
        </el-dialog>

    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2022-02-15 13:10:16

    import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
    import EmFilterTree from "@/components/em/EmFilterTree";
    import EmFilter from "@/components/em/EmFilter";
    import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
    import emApiMixin from "@/mixin/em/common/api";

    export default {
        name: "emLocationLevelTreeListView",
        mixins: [emLevelTreeListMixin,emCommonGotoMixin,emApiMixin,emTableCheckedMixin],
        components: {DrawerHandler, EmFilter, EmFilterTree},
        data() {
            return{
              copyJpkDialogVisible: false,
              createForm: {
                code: 'JPK'
              },
              rules: {
                code: [{required: true, message: '要同步的机旁库位置编码不能为空'}]
              },
            }
        },
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        methods:{
          openJpkDialog() {
            this.copyJpkDialogVisible = true;
          },
          clearCreateForm() {
            this.createForm.code = '';
            this.$refs["createForm"].resetFields();
          },
          copyJpkRecords() {
            let self = this;

            let url = `${this.$_emApiMixin_entityBaseApi("emLocation")}/copyJpkRecords`;
            console.log("复制备件的提交地址：")
            console.log(url)


            self.$_emApiMixin_post(url, self.createForm)
                .then((request) => {
                  if (request.status === 200) {
                    self.$message({
                      message: "同步成功",
                      type: "success",
                    });
                    self.$refs["emListFilter"].doQuery()
                  } else {
                    self.$message({
                      message: "同步失败",
                      type: "error",
                    });
                  }
                }).finally(() => {
              this.copyJpkDialogVisible = false;
            })

          },
        }
    }
</script>
